class ProductFormFabricTabs {
  constructor() {
    this.handleClick = this.handleClick.bind(this);
    document.addEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const variantFabricButton = event.target.closest(
      '[data-variant-fabric-option]',
    );

    if (variantFabricButton) {
      this.handleVariantFabricClick(variantFabricButton);
      return;
    }

    const button = event.target.closest('[data-fabric-option]');
    if (!button) return;

    const container = button.closest('[data-product-form-selectors]');
    if (!container) return;

    const handle = button.dataset.fabricHandle;

    container
      .querySelectorAll('[data-fabric-option]')
      .forEach((el) => {
        const active = el === button;
        el.classList.toggle(
          'product-fabric-option--selected',
          active,
        );
        el.setAttribute('aria-selected', String(active));
      });

    container
      .querySelectorAll('[data-fabric-panel]')
      .forEach((panel) => {
        panel.hidden = panel.dataset.fabricHandle !== handle;
      });

    const label = container.querySelector(
      '[data-fabric-selected-value]',
    );
    if (label) label.textContent = button.textContent.trim();

    const currentColor = container
      .querySelector('.product-swatch--selected')
      ?.getAttribute('title');

    if (currentColor) {
      const match = container.querySelector(
        `[data-fabric-panel][data-fabric-handle="${handle}"] [data-product-swatch-link][title="${CSS.escape(currentColor)}"]`,
      );
      if (match) match.classList.add('product-swatch--selected');
    }
  }

  handleVariantFabricClick(button) {
    const container = button.closest('[data-product-form-selectors]');
    if (!container) return;

    const fabricValue = (button.dataset.fabricValue || '').toLowerCase();

    container
      .querySelectorAll('[data-variant-fabric-option]')
      .forEach((el) => {
        const active = el === button;
        el.classList.toggle('product-fabric-option--selected', active);
        el.setAttribute('aria-selected', String(active));
      });

    const label = container.querySelector(
      '[data-variant-fabric-selected-value]',
    );
    if (label) label.textContent = button.textContent.trim();

    container
      .querySelectorAll('label[data-variant-fabric]')
      .forEach((colorLabel) => {
        const matches =
          (colorLabel.dataset.variantFabric || '').toLowerCase() ===
          fabricValue;
        colorLabel.hidden = !matches;
      });

    const checkedInput = container.querySelector(
      'label[data-variant-fabric] [data-product-option-input]:checked',
    );
    const checkedLabel = checkedInput?.closest('label');

    if (checkedInput && (!checkedLabel || checkedLabel.hidden)) {
      checkedInput.checked = false;
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else {

      container.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

window.ProductFormFabricTabs = ProductFormFabricTabs;

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductFormFabricTabs();
  });
} else {
  new ProductFormFabricTabs();
}